'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CareTypeService = function CareTypeService($http, $rootScope) {

    var careTypeArray = [];

    /**
     * Get the list of care types
     */

    var data = function data() {
        if (careTypeArray.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            careTypeArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.refcode/query?domain=CARE').then(function (response) {
                return response.data;
            });
        }

        return careTypeArray;
    };

    return { data: data };
};

exports.default = CareTypeService;


// WEBPACK FOOTER //
// ./client/app/common/services/careType.service.js